import { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useLayoutEffect } from 'react';
import { Box, Container, Grid, createTheme, ThemeProvider, CssBaseline } from '@mui/material';

// Create the same theme as in App.js
const theme = createTheme({
  components: {
    MuiDataGrid: {
      defaultProps: {
        density: 'compact',
      },
    }
  }
});
const NewWindowPortal = ({ children, title = '', onClose, }) => {
  const newWindow = useRef(null);
  const containerEl = useRef(document.createElement('div'));

  // Style loading takes few seconds, so we keep loading for 5 seconds
  const [count, setCount] = useState(5);

  useLayoutEffect(() => {
    const interval = setInterval(() => {
      setCount(prevCount => {
        if (prevCount <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useLayoutEffect(() => {
    // Use unique window name for each portal
    newWindow.current = window.open('', title, 'width=800,height=400,location=0,toolbar=0,menubar=0,status=0');
    newWindow.current.document.title = title;

    // Copy all <link> and <style> tags from parent <head> to new window <head>
    const newHead = newWindow.current.document.head;

    // Copy all stylesheets including dynamically created ones
    const styleSheets = Array.from(document.styleSheets);
    styleSheets.forEach(styleSheet => {
      try {
        if (styleSheet.cssRules && styleSheet.cssRules.length > 0) {
          // For inline styles and dynamically created styles (like Material-UI)
          const newStyleEl = newWindow.current.document.createElement('style');
          Array.from(styleSheet.cssRules).forEach(rule => {
            newStyleEl.appendChild(newWindow.current.document.createTextNode(rule.cssText));
          });
          newHead.appendChild(newStyleEl);
        }
      } catch (e) {
        // CORS might prevent accessing cssRules for some external stylesheets
        console.warn('Could not copy stylesheet', e);
      }
    });

    // Add zoom style
    const zoomStyle = newWindow.current.document.createElement('style');
    zoomStyle.innerHTML = 'body { zoom: 80%; }'; // Set zoom to 80%
    newHead.appendChild(zoomStyle);

    newWindow.current.document.body.appendChild(containerEl.current);

    const curWindow = newWindow.current;
    curWindow.onbeforeunload = () => onClose && onClose();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  // Wrap children in ThemeProvider to ensure Material-UI components are styled correctly
  // Also add Box, Container, and Grid components to match App.js structure
  return ReactDOM.createPortal(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box style={{ background: '#F1F4FD' }}>
        <Box sx={{ m: 0.25 }}>
          <Container maxWidth={false} sx={{ width: '99%' }}>
            <Grid container rowSpacing={{ xs: 1, sm: 2, md: 2, xl: 2 }}
              columnSpacing={{ xs: 1, sm: 2, md: 2, xl: 2 }} sx={{ m: 1 }}
            >
              {children}
            </Grid>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>, containerEl.current
  );
};

export default NewWindowPortal;